import { useQuery } from '@tanstack/react-query';
import { LocationsService } from './locations.service';
import { QUERY_STALE_MS } from './query-stale-time';

const locationsService = new LocationsService();

export const locationKeys = {
  all: ['locations'] as const,
  countries: () => [...locationKeys.all, 'countries'] as const,
  states: (countryId: string) => [...locationKeys.all, 'states', countryId] as const,
  districts: (stateId: string) => [...locationKeys.all, 'districts', stateId] as const,
};

export function useCountries(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: locationKeys.countries(),
    queryFn: () => locationsService.getCountries(),
    enabled: options?.enabled ?? true,
    staleTime: QUERY_STALE_MS.REFERENCE,
  });
}

export function useStates(countryId: string | undefined) {
  return useQuery({
    queryKey: locationKeys.states(countryId ?? ''),
    queryFn: () => locationsService.getStates(countryId!),
    enabled: !!countryId,
    staleTime: QUERY_STALE_MS.REFERENCE,
  });
}

export function useDistricts(stateId: string | undefined) {
  return useQuery({
    queryKey: locationKeys.districts(stateId ?? ''),
    queryFn: () => locationsService.getDistricts(stateId!),
    enabled: !!stateId,
    staleTime: QUERY_STALE_MS.REFERENCE,
  });
}
